export const FULLSCREEN_ROOT = 'fullscreen-root';
export const FULLSCREEN_CLOSE_BUTTON = 'fullscreen-close-button';
export const FULLSCREEN_TOGGLE_BUTTON = 'fullscreen-toggle-button';
export const FULLSCREEN_IMAGE_ITEM = 'fullscreen-image-item';
